import type { ComponentPropsWithoutRef } from "react";

import { COVER_IMAGE_CONTAINER_ID } from "../constants";

export const CoverImageContainer = ({
  ...props
}: Omit<ComponentPropsWithoutRef<"div">, "id">) => (
  <div
    {...props}
    id={COVER_IMAGE_CONTAINER_ID}
    data-testid="cover-image-container"
  />
);
